import {useQuery} from '@tanstack/react-query';

import {experimentQueryKeyForList} from 'apps/experiments/src/react-query';
import {useExperimentsApi} from 'apps/experiments/src/api/experiments';

type FetchExperimentListParams = {
  projectId: number;
  workspaceId: number;
};

export function useQueryExperimentList({projectId, workspaceId}: FetchExperimentListParams) {
  const {listExperiments} = useExperimentsApi({
    projectId,
    workspaceId,
  });

  const {data, isError, error, isSuccess, isLoading} = useQuery({
    queryKey: experimentQueryKeyForList(projectId, workspaceId),
    staleTime: 5 * 60 * 1000, // 5 minutes
    queryFn: async () => {
      return listExperiments();
    },
  });

  return {
    error,
    experiments: data?.results,
    experimentsLimit: data?.limit ?? -1,
    isError,
    isLoading,
    isSuccess,
  };
}
